// import {
//   ChartAnnotationService,
//   StripLineService,
// } from "@syncfusion/ej2-angular-charts";
import { NgModule } from "@angular/core";
import {
  ListBoxAllModule,
  DropDownListModule,
  MultiSelectAllModule,
  CheckBoxSelectionService,
  MultiSelectModule,
  VirtualScroll,
  DropDownTreeModule
} from "@syncfusion/ej2-angular-dropdowns";
import { DashboardLayoutModule } from "@syncfusion/ej2-angular-layouts";
import { DateRangePickerModule } from "@syncfusion/ej2-angular-calendars";
import { StepLineSeriesService } from "@syncfusion/ej2-angular-charts";
import { ButtonModule, CheckBoxModule } from "@syncfusion/ej2-angular-buttons";
import { TextBox, TextBoxModule, UploaderModule } from "@syncfusion/ej2-angular-inputs";
import { ListViewModule, VirtualizationService } from "@syncfusion/ej2-angular-lists";
import { TreeViewModule } from "@syncfusion/ej2-angular-navigations";

const SYNCFUSION_MODULES = [
  MultiSelectAllModule,
  MultiSelectModule,
  ListBoxAllModule,
  ListViewModule,
  DropDownListModule,
  DashboardLayoutModule,
  DateRangePickerModule,
  ButtonModule,
  CheckBoxModule,
  UploaderModule,
  TreeViewModule,
  TextBoxModule,
  DropDownTreeModule
];

@NgModule({
  imports: [SYNCFUSION_MODULES],
  exports: [SYNCFUSION_MODULES],
  declarations: [],
  providers: [
    VirtualizationService,
    StepLineSeriesService,
    CheckBoxSelectionService,
  ],
})
export class SyncfusionModule {}
